import{ANY_TOKEN,ANY_DEEP_TOKEN}from"./any.js";
import{INDEX_TOKEN}from"./indices.js";
import{REGEXP_TOKEN}from"./regexp.js";
import{SLICE_TOKEN}from"./slice.js";



export const getOtherStringTokenType=(chars)=>
OTHER_STRING_TOKEN_TYPES.find((tokenType)=>tokenType.testString(chars));



export const OTHER_STRING_TOKEN_TYPES=[
ANY_TOKEN,
ANY_DEEP_TOKEN,
REGEXP_TOKEN,
SLICE_TOKEN,
INDEX_TOKEN];

export const OTHER_OBJECT_TOKEN_TYPES=[
INDEX_TOKEN,
ANY_TOKEN,
ANY_DEEP_TOKEN,
REGEXP_TOKEN,
SLICE_TOKEN];